// extracted by mini-css-extract-plugin
export default {"container":"TabBarItem_container__WqbPY","titleText":"TabBarItem_titleText__mjmLG","underLine":"TabBarItem_underLine__K0oiE"};